/* DEPRECATED */
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { isFunction, isInteger, noop } from 'lodash';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import formField from 'Components/frameworks/form-field/FormField.jsx';

const propTypes = {
  autoComplete: PropTypes.oneOf(['on', 'off', 'nope']),
  dataSelector: PropTypes.string,
  hasClear: PropTypes.bool,
  height: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isNotEditable: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['email', 'password', 'search', 'tel', 'text', 'url']),
};

const defaultProps = {
  autoComplete: 'on',
  dataSelector: 'FormInputText',
  hasClear: false,
  isDisabled: false,
  isNotEditable: false,
  isReadOnly: false,
  isRequired: false,
  onBlur: noop,
  onChange: noop,
  onClear: noop,
  onClick: noop,
  onFocus: noop,
  onKeyDown: noop,
  onKeyUp: noop,
  type: 'text',
};

class FormInputText extends React.Component<Props> {
  static displayName = 'FormInputText';

  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
    };
  }

  UNSAFE_componentWillReceiveProps({ value }) {
    if (this.props.value !== value) {
      this.setState({ value });
    }
  }

  onChange = e => {
    e.persist();
    const { value } = e.target;

    this.setState(
      {
        value,
      },
      () => this.props.onChange(value),
    );
  };

  onKeyDown = e => {
    e.persist();
    if (isFunction(this.props.onKeyDown)) {
      this.props.onKeyDown(e);
    }
  };

  onClear = e => {
    e.stopPropagation();

    this.setState(
      {
        value: '',
      },
      this.props.onClear,
    );
  };

  render() {
    const {
      dataSelector,
      hasClear,
      height,
      id,
      isDisabled,
      isLoading,
      isNotEditable,
      isReadOnly,
      isRequired,
      maxLength,
      name,
      onBlur,
      onClick,
      onFocus,
      onKeyUp,
      pattern,
      placeholder,
      type,
    } = this.props;

    const { value } = this.state;

    const computePlaceholder = isRequired ? `${placeholder}*` : placeholder;

    return (
      <div className="flex-1 relative">
        <input
          autoComplete={this.props.autoComplete}
          className={classnames('reset-input bg-transparent py-3 px-4 text-md w-full', {
            'text-gray-dark': !isReadOnly && !value,
            'text-black': isReadOnly || value,
            'pointer-events-none': isReadOnly,
            'rtl:pr-15': hasClear,
            'cursor-not-allowed': isDisabled,
            'cursor-progress': isLoading && !isDisabled,
          })}
          data-selector={dataSelector}
          disabled={isDisabled}
          {...(id ? { id } : null)}
          {...(isInteger(maxLength) && maxLength > 0 ? { maxLength } : null)}
          {...(name ? { name } : null)}
          onBlur={onBlur}
          onChange={this.onChange}
          onClick={onClick}
          onFocus={onFocus}
          onKeyDown={this.onKeyDown}
          onKeyUp={onKeyUp}
          {...(pattern ? { pattern } : null)}
          {...(placeholder ? { placeholder: computePlaceholder } : null)}
          style={{
            height,
          }}
          readOnly={isReadOnly || isNotEditable}
          required={isRequired}
          role={type === 'search' ? 'search' : 'textbox'}
          type={type ? type : 'text'}
          value={value}
        />
        {hasClear &&
          !isDisabled &&
          !isReadOnly &&
          value && (
            <button
              className="absolute bg-white border-current border-solid border-1 flex items-center justify-center rtl:mr-4 outline-none rtl:right-0 rounded-full text-gray-medium focus:text-blue hover:text-blue top-1/2 transition-all -translate-y-50"
              onClick={this.onClear}
              style={{ width: '1.875rem', height: '1.875rem' }}
              type="button"
            >
              <Icon name={ICONS.CROSS} width="0.625rem" />
            </button>
          )}
      </div>
    );
  }
}

FormInputText.propTypes = propTypes;
FormInputText.defaultProps = defaultProps;

export default formField(FormInputText);
